<template>
  <v-app-bar
    max-height="48"
    class="gradiente-topo px-2 px-sm-0"
    :fixed="app"
    dense
    flat
    @click="verificarMenuAberto"
  >
    <v-btn
      v-if="logado"
      icon
      small
      color="white"
      class="ml-sm-2 hidden-md-and-up"
      data-cy="button_menu"
      @click.stop="abrirFecharMenu"
    >
      <v-icon>{{ changeIcone }}</v-icon>
    </v-btn>
    <router-link
      :to="linkLogo"
      data-cy="link_logo"
      class="mx-auto mx-md-0 pr-md-6"
    >
      <v-img
        src="~@/assets/img/logo.svg"
        aspect-ratio="1"
        contain
        height="25"
        width="153"
      />
    </router-link>
    <p
      v-if="logado"
      class="white--text hidden-sm-and-down mb-0 body-2 py-1 pl-6"
      style="border-left: 1px solid #FFF;"
    >
      A solução definitiva de pagamentos online
    </p>
    <v-btn
      v-if="logado"
      :class="[
        $vuetify.breakpoint.mdAndUp ? 'btn-desktop' : '',
        $vuetify.breakpoint.md ? 'btn-desktop--md' : '',
        $vuetify.breakpoint.lgAndUp ? 'btn-desktop--lg' : '',
      ]"
      :icon="$vuetify.breakpoint.smAndDown"
      :text="$vuetify.breakpoint.mdAndUp"
      small
      target="_blank"
      color="white"
      class="mr-sm-2"
      href="https://ajuda.monetizze.com.br/hc/pt-br/categories/360002019152-Compras-atrav%C3%A9s-da-Monetizze"
      data-cy="button_central_ajuda"
      @click="scoreConsumidor"
    >
      <v-icon>
        fas fa-question-circle
      </v-icon>
      <span
        v-if="$vuetify.breakpoint.mdAndUp"
        class="btn-text ml-md-2 body-1"
      >
        Central de Ajuda
      </span>
    </v-btn>
  </v-app-bar>
</template>
<script>
import api from '@/api';

export default {
  name: 'Topo',

  props: {
    logado: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    app() {
      return this.logado;
    },

    changeIcone() {
      return this.$store.state.menuAberto ? 'mdi-close' : 'mdi-menu';
    },

    linkLogo() {
      return this.logado ? '/minhas-compras' : '/login';
    },
  },

  methods: {
    async scoreConsumidor() {
      await api.post('/consumer_score', {
        action: 'help_center',
      });
    },

    abrirFecharMenu() {
      this.menu = !this.$store.state.menuAberto;
      this.$store.dispatch('setMenuAberto', this.menu);
    },

    verificarMenuAberto() {
      if (this.$store.state.menuAberto) {
        this.$store.dispatch('setMenuAberto', !this.$store.state.menuAberto);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.btn-text { text-transform: none; }

.btn-desktop {
  position: absolute !important;

  &--lg { left: calc(50vw + 445px); }
  &--md { right: 0; }
}
</style>
